/////////////////////////////
/// ITW BOAT SEARCH FORM ///
function initBoatsearchSlick(){

    consolog("initBoatsearchSlick()");

    if($("#searchresult_id").length > 0){

        $("#searchresult_id").find(".paging").find(".btn").click(function () {
            
            consolog("initBoatsearchSlick() click");
            
            $('html, body').animate({
                scrollTop: $("#searchresult_id").offset().top-50
            }, 500);
            
            setTimeout(initBoatsearchSlick, 500);
            
            return true;
        });
        $("#searchresult_id").find(".paging").find(".btn").on("keydown", handleKeyDownForClick);
    }
}

function handleBoatSelectYearOpened($ns) {

    //consolog("handleBoatSelectYearOpened()");
    
    var $sl = $ns.closest(".slick-list");
    $sl.css("padding-top", "200px");
    $sl.css("margin-top", "-200px");
    $sl.css("padding-bottom", "200px");
    $sl.css("margin-bottom", "-200px");
    $sl.css("height", "auto");
    
    setTimeout(function () {
        $sl.css("padding-top", "200px");
        $sl.css("margin-top", "-200px");
        $sl.css("padding-bottom", "200px");
        $sl.css("margin-bottom", "-200px");
        $sl.css("height", "auto");
        $("body").unbind().mousedown(function (event) {            
            handleBoatSelectYearClosed();
        });
    }, 500);
}

function handleBoatSelectYearClosed() {
    
    //consolog("handleBoatSelectYearClosed()");
    
    $("body").unbind();
    $(".boatsearchSlick").find(".slick-list").css("padding-top", 0);
    $(".boatsearchSlick").find(".slick-list").css("margin-top", 0);
    $(".boatsearchSlick").find(".slick-list").css("padding-bottom", 0);
    $(".boatsearchSlick").find(".slick-list").css("margin-bottom", 0);
}